import React, { useEffect, useMemo, useState } from 'react';
import Modal from '../common/Modal';
import ConfirmDialog from '../common/ConfirmDialog';
import './ModalForms.css';
import '../common/IconButton.css';
import { IconTrash } from '../common/Icons';

const emptyExpense = {
  date: '',
  description: '',
  value: '',
  currency: 'USD',
  conversion: '',
  isFromFede: 0
};

const ExpenseModal = ({ isOpen, onClose, onSave, onDelete, initialData }) => {
  const [formData, setFormData] = useState(emptyExpense);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const conversionDisabled = useMemo(() => formData.currency !== '$', [formData.currency]);

  useEffect(() => {
    if (initialData) {
      setFormData({
        date: initialData.date ? initialData.date.slice(0, 10) : '',
        description: initialData.description || '',
        value: initialData.value ?? '',
        currency: initialData.currency || 'USD',
        conversion: initialData.conversion ?? '',
        isFromFede: Number(initialData.isFromFede) === 1 ? 1 : 0
      });
    } else {
      const today = new Date().toISOString().slice(0, 10);
      setFormData({ ...emptyExpense, date: today });
    }
  }, [initialData, isOpen]);

  useEffect(() => {
    if (conversionDisabled) {
      setFormData((prev) => ({ ...prev, conversion: '' }));
    }
  }, [conversionDisabled]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFromFedeChange = (e) => {
    setFormData((prev) => ({ ...prev, isFromFede: e.target.checked ? 1 : 0 }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave({
      ...formData,
      value: formData.value === '' ? '' : Number(formData.value),
      conversion:
        formData.currency === '$' && formData.conversion !== '' ? Number(formData.conversion) : null
    });
  };

  return (
    <Modal
      title={initialData ? 'Editar Gasto' : 'Nuevo Gasto'}
      isOpen={isOpen}
      onClose={onClose}
      onEnter={() => handleSubmit()}
      footer={(
        <div className="modal-footer">
          <div className="footer-left">
            {initialData && onDelete && (
              <button
                type="button"
                className="icon-btn icon-btn--delete"
                onClick={() => setConfirmOpen(true)}
                aria-label="Eliminar gasto"
                title="Eliminar"
              >
                <IconTrash />
              </button>
            )}
          </div>
          <div className="footer-actions">
            <button type="button" className="btn secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" form="expense-modal-form" className="btn">Guardar</button>
          </div>
        </div>
      )}
    >
      <form id="expense-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Fecha
            <input type="date" name="date" value={formData.date} onChange={handleChange} required />
          </label>
          <label>
            Descripción
            <input name="description" value={formData.description} onChange={handleChange} required />
          </label>
          <label>
            Moneda
            <select name="currency" value={formData.currency} onChange={handleChange}>
              <option value="USD">USD</option>
              <option value="$">$</option>
            </select>
          </label>
          <label>
            Importe
            <input
              type="number"
              step="0.01"
              name="value"
              value={formData.value}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Conversión
            <input
              type="number"
              step="0.000001"
              name="conversion"
              value={formData.conversion}
              onChange={handleChange}
              disabled={conversionDisabled}
              placeholder={conversionDisabled ? '—' : 'Tipo de cambio'}
            />
          </label>
          <label className="form-checkbox form-checkbox--stacked">
            Gasto de Fede
            <input
              type="checkbox"
              name="isFromFede"
              checked={formData.isFromFede === 1}
              onChange={handleFromFedeChange}
            />
          </label>
        </div>

      </form>

      <ConfirmDialog
        isOpen={confirmOpen}
        title="Eliminar gasto"
        message="¿Está seguro que desea eliminar este gasto?"
        confirmLabel="Eliminar"
        cancelLabel="Cancelar"
        onConfirm={() => {
          setConfirmOpen(false);
          onDelete?.(initialData?.id);
        }}
        onCancel={() => setConfirmOpen(false)}
      />
    </Modal>
  );
};

export default ExpenseModal;

